import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: require('@/views/Home.vue').default
  },
  {
    path: '/fixedmode',
    name: 'fixedmode',
    component: require('@/views/Fixedmode.vue').default
  },
  {
    path: '/split',
    name: 'split',
    component: require('@/views/Split.vue').default,
    meta: {
      isContents: true
    }
  },
  {
    path: '/split/twitter',
    name: 'split.twitter',
    component: require('@/views/SplitTwitter.vue').default
  },
  {
    path: '/split/train',
    name: 'split.train',
    component: require('@/views/SplitTrain.vue').default
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
